import React from 'react';
import {
  Alert,
  HospitalDepartment,
  ServiceGroupItem,
  Service,
} from '@quality24/inpatient-typings';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { Text } from '@quality24/design-system';

import ActiveAlertCard from '@/inpatient-patient-pwa/molecules/ActiveAlertCard';

export interface Props {
  className?: string;
  alerts: Array<ExtendedAlert>;
  hideElapsedTime?: boolean;
}

interface ExtendedAlert extends Required<Pick<Alert, 'id' | 'createdAt'>> {
  group: Pick<ServiceGroupItem, 'id' | 'name' | 'nameI18N'> & {
    service: Required<Pick<Service, 'id' | 'reason' | 'reasonI18N'>> & {
      department: Required<
        Pick<HospitalDepartment, 'id' | 'name' | 'nameI18N'>
      >;
    };
  };
}

const ActiveAlertList: React.FunctionComponent<Props> = ({
  className,
  alerts,
  hideElapsedTime,
}) => {
  const { t } = useTranslation();
  return (
    <div
      className={classNames('d-flex flex-column gap-2', className)}
      role="list"
    >
      {alerts.length === 0 && <Text>{t('alerts.noActive')}</Text>}

      {alerts.map((alert) => (
        <ActiveAlertCard
          key={alert.id}
          alert={alert}
          hideElapsedTime={hideElapsedTime}
        />
      ))}
    </div>
  );
};

export default ActiveAlertList;
